import { HttpClient, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { appendToRmaIdentityUrl } from '@rma/common-ui-ng/util';
import { rmaProperties } from '@rma/generic/util/environment';
import * as qs from 'qs';
import { Observable } from 'rxjs';

import { IdentityToken } from './auth-api.types';

@Injectable({
  providedIn: 'root',
})
export class OAuthApiService {
  private readonly httpClient = inject(HttpClient);
  private readonly identityUrl = inject(appendToRmaIdentityUrl);

  public login(email: string, password: string): Observable<void> {
    const params = { email, password, client: rmaProperties.identityClient };
    return this.httpClient.post<void>(this.identityUrl('Users/Me/Login'), params, { withCredentials: true });
  }

  public authorize(): Observable<HttpResponse<void>> {
    const params = {
      client_id: rmaProperties.identityClient,
      scope: 'openid profile offline_access rma.api',
      response_type: 'code',
      redirect_uri: this.identityUrl('/Users/Me/Login/Callback'),
    };
    return this.httpClient.get<void>(this.identityUrl('/connect/authorize'), {
      params,
      observe: 'response',
      withCredentials: true,
    });
  }

  public getAccessToken(url: string): Observable<IdentityToken> {
    const query = qs.parse(new URL(url).search.slice(1));

    const params = new HttpParams({
      fromObject: {
        // TODO: this seems very insecure !!! pretty sure if we ever want to use this we should move it to the backend?
        /*client_id: rmaProperties.identityClient,
        client_secret: rmaProperties.identitySecret,*/
        grant_type: 'authorization_code',
        code: query['code'] as string,
        redirect_uri: this.identityUrl('/Users/Me/Login/Callback'),
      },
    });

    return this.retrieveAccessToken(params);
  }

  public refreshToken(refreshToken: string): Observable<IdentityToken> {
    const params = new HttpParams({
      fromObject: {
        // TODO: this seems very insecure !!! pretty sure if we ever want to use this we should move it to the backend?
        /*client_id: rmaProperties.identityClient,
        client_secret: rmaProperties.identitySecret,*/
        grant_type: 'refresh_token',
        refresh_token: refreshToken,
      },
    });

    return this.retrieveAccessToken(params);
  }

  private retrieveAccessToken(params: HttpParams): Observable<IdentityToken> {
    const headers = new HttpHeaders().set('Content-Type', 'application/x-www-form-urlencoded');

    const apiUrl = this.identityUrl('/connect/token');

    return this.httpClient.post<IdentityToken>(apiUrl, params, { headers });
  }
}
